/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddSalesPriceModelAssignment} from '../bioplanModels';
// @ts-ignore
import type {SalesPriceModelAssignment} from '../bioplanModels';
/**
 * SalesPriceModelAssignmentApi - axios parameter creator
 * @export
 */
export const SalesPriceModelAssignmentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsAssignmentIdDelete: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('salesPriceModelAssignmentsAssignmentIdDelete', 'assignmentId', assignmentId);
      const localVarPath = `/salesPriceModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsAssignmentIdGet: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('salesPriceModelAssignmentsAssignmentIdGet', 'assignmentId', assignmentId);
      const localVarPath = `/salesPriceModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assignmentId
     * @param {SalesPriceModelAssignment} salesPriceModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsAssignmentIdPut: async (
      assignmentId: string,
      salesPriceModelAssignment: SalesPriceModelAssignment,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('salesPriceModelAssignmentsAssignmentIdPut', 'assignmentId', assignmentId);
      // verify required parameter 'salesPriceModelAssignment' is not null or undefined
      assertParamExists(
        'salesPriceModelAssignmentsAssignmentIdPut',
        'salesPriceModelAssignment',
        salesPriceModelAssignment,
      );
      const localVarPath = `/salesPriceModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        salesPriceModelAssignment,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('salesPriceModelAssignmentsGet', 'planId', planId);
      const localVarPath = `/salesPriceModelAssignments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddSalesPriceModelAssignment} addSalesPriceModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsPost: async (
      addSalesPriceModelAssignment: AddSalesPriceModelAssignment,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addSalesPriceModelAssignment' is not null or undefined
      assertParamExists('salesPriceModelAssignmentsPost', 'addSalesPriceModelAssignment', addSalesPriceModelAssignment);
      const localVarPath = `/salesPriceModelAssignments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        addSalesPriceModelAssignment,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SalesPriceModelAssignmentApi - functional programming interface
 * @export
 */
export const SalesPriceModelAssignmentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SalesPriceModelAssignmentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelAssignmentsAssignmentIdDelete(
      assignmentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelAssignmentsAssignmentIdDelete(
        assignmentId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelAssignmentApi.salesPriceModelAssignmentsAssignmentIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelAssignmentsAssignmentIdGet(
      assignmentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelAssignmentsAssignmentIdGet(
        assignmentId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelAssignmentApi.salesPriceModelAssignmentsAssignmentIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assignmentId
     * @param {SalesPriceModelAssignment} salesPriceModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelAssignmentsAssignmentIdPut(
      assignmentId: string,
      salesPriceModelAssignment: SalesPriceModelAssignment,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelAssignmentsAssignmentIdPut(
        assignmentId,
        salesPriceModelAssignment,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelAssignmentApi.salesPriceModelAssignmentsAssignmentIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelAssignmentsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesPriceModelAssignment>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelAssignmentsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelAssignmentApi.salesPriceModelAssignmentsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AddSalesPriceModelAssignment} addSalesPriceModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelAssignmentsPost(
      addSalesPriceModelAssignment: AddSalesPriceModelAssignment,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelAssignmentsPost(
        addSalesPriceModelAssignment,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelAssignmentApi.salesPriceModelAssignmentsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SalesPriceModelAssignmentApi - factory interface
 * @export
 */
export const SalesPriceModelAssignmentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SalesPriceModelAssignmentApiFp(configuration);
  return {
    /**
     *
     * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsAssignmentIdDelete(
      requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .salesPriceModelAssignmentsAssignmentIdDelete(requestParameters.assignmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsAssignmentIdGet(
      requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModelAssignment> {
      return localVarFp
        .salesPriceModelAssignmentsAssignmentIdGet(requestParameters.assignmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsAssignmentIdPut(
      requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModelAssignment> {
      return localVarFp
        .salesPriceModelAssignmentsAssignmentIdPut(
          requestParameters.assignmentId,
          requestParameters.salesPriceModelAssignment,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsGet(
      requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SalesPriceModelAssignment>> {
      return localVarFp
        .salesPriceModelAssignmentsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelAssignmentsPost(
      requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModelAssignment> {
      return localVarFp
        .salesPriceModelAssignmentsPost(requestParameters.addSalesPriceModelAssignment, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for salesPriceModelAssignmentsAssignmentIdDelete operation in SalesPriceModelAssignmentApi.
 * @export
 * @interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdDeleteRequest
 */
export interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdDelete
   */
  readonly assignmentId: string;
}

/**
 * Request parameters for salesPriceModelAssignmentsAssignmentIdGet operation in SalesPriceModelAssignmentApi.
 * @export
 * @interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdGetRequest
 */
export interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdGet
   */
  readonly assignmentId: string;
}

/**
 * Request parameters for salesPriceModelAssignmentsAssignmentIdPut operation in SalesPriceModelAssignmentApi.
 * @export
 * @interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPutRequest
 */
export interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPut
   */
  readonly assignmentId: string;

  /**
   *
   * @type {SalesPriceModelAssignment}
   * @memberof SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPut
   */
  readonly salesPriceModelAssignment: SalesPriceModelAssignment;
}

/**
 * Request parameters for salesPriceModelAssignmentsGet operation in SalesPriceModelAssignmentApi.
 * @export
 * @interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsGetRequest
 */
export interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsGetRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelAssignmentApiSalesPriceModelAssignmentsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for salesPriceModelAssignmentsPost operation in SalesPriceModelAssignmentApi.
 * @export
 * @interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsPostRequest
 */
export interface SalesPriceModelAssignmentApiSalesPriceModelAssignmentsPostRequest {
  /**
   *
   * @type {AddSalesPriceModelAssignment}
   * @memberof SalesPriceModelAssignmentApiSalesPriceModelAssignmentsPost
   */
  readonly addSalesPriceModelAssignment: AddSalesPriceModelAssignment;
}

/**
 * SalesPriceModelAssignmentApi - object-oriented interface
 * @export
 * @class SalesPriceModelAssignmentApi
 * @extends {BaseAPI}
 */
export class SalesPriceModelAssignmentApi extends BaseAPI {
  /**
   *
   * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelAssignmentApi
   */
  public salesPriceModelAssignmentsAssignmentIdDelete(
    requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelAssignmentApiFp(this.configuration)
      .salesPriceModelAssignmentsAssignmentIdDelete(requestParameters.assignmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelAssignmentApi
   */
  public salesPriceModelAssignmentsAssignmentIdGet(
    requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelAssignmentApiFp(this.configuration)
      .salesPriceModelAssignmentsAssignmentIdGet(requestParameters.assignmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelAssignmentApi
   */
  public salesPriceModelAssignmentsAssignmentIdPut(
    requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsAssignmentIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelAssignmentApiFp(this.configuration)
      .salesPriceModelAssignmentsAssignmentIdPut(
        requestParameters.assignmentId,
        requestParameters.salesPriceModelAssignment,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelAssignmentApi
   */
  public salesPriceModelAssignmentsGet(
    requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelAssignmentApiFp(this.configuration)
      .salesPriceModelAssignmentsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SalesPriceModelAssignmentApiSalesPriceModelAssignmentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelAssignmentApi
   */
  public salesPriceModelAssignmentsPost(
    requestParameters: SalesPriceModelAssignmentApiSalesPriceModelAssignmentsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelAssignmentApiFp(this.configuration)
      .salesPriceModelAssignmentsPost(requestParameters.addSalesPriceModelAssignment, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
